import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './Field.module.scss.js';
import FormLabel from '../FormLabel/index.js';
import FormFieldError from '../FormFieldError/index.js';

var _excluded = ["children", "description", "label", "input", "required", "className", "meta"];
var FormField = function FormField(_ref) {
  var children = _ref.children,
    description = _ref.description,
    label = _ref.label,
    input = _ref.input,
    required = _ref.required,
    className = _ref.className,
    meta = _ref.meta,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(style.field, className)
  }, props), label && /*#__PURE__*/React.createElement(FormLabel, {
    name: input === null || input === void 0 ? void 0 : input.name,
    className: cx(style.name),
    required: required
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: cx(style.required)
  }, "*")), description && /*#__PURE__*/React.createElement("span", null, description), children, /*#__PURE__*/React.createElement(FormFieldError, {
    name: input === null || input === void 0 ? void 0 : input.name,
    meta: meta
  }));
};
var FormFieldInputPropTypes = {
  name: PropTypes.string
};
var FormFieldPropTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
FormField.propTypes = Object.assign({}, FormFieldPropTypes, {
  children: PropTypes.node,
  input: PropTypes.shape(FormFieldInputPropTypes).isRequired,
  label: PropTypes.node,
  meta: PropTypes.object,
  required: PropTypes.bool
});
FormField.defaultProps = {
  meta: {}
};

export { FormFieldInputPropTypes, FormFieldPropTypes, FormField as default };
//# sourceMappingURL=index.js.map
